import img1 from "../Assets/imgIlustracion/mujer editada.jpg"
import img2 from "../Assets/imgIlustracion/mural editado.jpg"

export const CardIlustracion = [
    {
        img1: img1,
        img2: img2
    },
]